import { render, staticRenderFns } from "./TownSelect.vue?vue&type=template&id=5a6be302"
import script from "./TownSelect.vue?vue&type=script&lang=ts"
export * from "./TownSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports